<mat-card appearance="outlined">
  <mat-card-content>
    <div class="zwi-book-menu">
      <div class="zwi-book-menu__old-testament">
        <div class="mat-subtitle-2">Old Testament</div>
        <div class="zwi-book-menu__books">
          @for (book of oldTestament; track book) {
            <div (click)="selectBook(book)" class="zwi-book-menu__item">{{ book.name }}</div>
          }
        </div>
      </div>
      <div class="zwi-book-menu__new-testament">
        <div class="mat-subtitle-2">New Testament</div>
        <div class="zwi-book-menu__books">
          @for (book of newTestament; track book) {
            <div (click)="selectBook(book)" class="zwi-book-menu__item">{{ book.name }}</div>
          }
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
